var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed"},[_c('div',{ref:_vm.elementRef,staticClass:"fds-container",attrs:{"data-fds-tenant":_vm.tennant}})])}
var staticRenderFns = []

export { render, staticRenderFns }